import React, { useEffect, useState } from "react";
import UserMonthlyChart from "../../../components/detail/UserMonthlyChart";
import useAnalytics from "./AnalyticsHook";
import CommonTable from "../../../components/tables/CommonTable";
import ChartWrapper from "./ChartWrapper";
import { Card } from "react-bootstrap";

const MonthlyUsageChart = ({ analyticsData, mode }) => {
  const [datasets, setDatasets] = useState(null);
  const { CalculateMonthlyTotals, MapToDateValuePairs } = useAnalytics();

  const columns = [
    {
      Header: "Month",
      accessor: "x",
      Cell: (cell) => {
        return cell.value.format("MMM YYYY");
      },
    },
    {
      Header: "Usage (minutes)",
      accessor: "y",
    },
  ];

  useEffect(() => {
    var datasets = [];
    const monthlyTotals = CalculateMonthlyTotals(analyticsData);

    datasets.push({
      type: "bar",
      label: "Usage (minutes)",
      data: MapToDateValuePairs(monthlyTotals, "total_session_seconds", 60.0),
    });

    setDatasets(datasets);
  }, [analyticsData]);

  return (
    <React.Fragment>
      {datasets && (
        <React.Fragment>
          <ChartWrapper mode={mode}>
            <UserMonthlyChart datasets={datasets} />
          </ChartWrapper>
          {mode === "page" && (
            <Card className="p-0">
              <CommonTable
                columns={columns}
                data={datasets[0].data}
                hideSearch={true}
                emptyMessage="No Data"
              />
            </Card>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default MonthlyUsageChart;
